module.exports = __webpack_public_path__ + "img/4.e1237068.png";